$(function() {

    /**
     * показываем\скрываем подсказку кнопку дообавления тура
     * */
    var hideAddTourPopoverSec = 3150;
    var addTourPopover = $("#add-tour-popover");
    var hideAddTourPopoverStatus = localStorage.getItem("hideAddTourPopover");
    if (hideAddTourPopoverStatus !== "true1") {
        addTourPopover.show();
        setTimeout(function() {addTourPopover.addClass("rightposition");}, 150);
        addTourPopover.on("click", function(event) {
            event.stopPropagation();
            $(this).hide();
            localStorage.setItem("hideAddTourPopover", "true1");
        });
        setTimeout(function() {addTourPopover.removeClass("rightposition");}, hideAddTourPopoverSec);
        setTimeout(function() {addTourPopover.hide();}, (hideAddTourPopoverSec + 300));
    }

    /**
     * блокировка кнопки отправки формы на 5 сек
     * */
    $("form.ajax-send-loader").on("submit", function() {
        var form = $(this);
        var submit = form.find("[type='submit']");
        submit.attr("disabled", "disabled");
        submit.append('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');

        setTimeout(function() {
            submit.find(".spinner-border").remove();
            submit.removeAttr("disabled");
        }, 25000);
    });

    /**
     * блокировка кнопки на 5 сек
     * */
    $("a.ajax-send-loader, button.ajax-send-loader").on("click", function() {
        var submit = $(this);
        submit.addClass("disabled");
        submit.append('<span style="color: #ccc" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');

        setTimeout(function() {
            submit.find(".spinner-border").remove();
            submit.removeClass("disabled");
        }, 25000);
    });


    /**
     * скролим страницу вверх при первом клике
     * */
    /*
    var logoClick = 0;
    $("header svg.logo").on("click", function() {
        logoClick++;
        if (logoClick == 1) {
            $("html, body").animate({ scrollTop: "0" });
            //return false;
        }
    });

     */

    /**
     * для того что бы фон был расплывчатый приоткрытии модального окна
     * */
    $(document).ready(function(){
        $('body div.modal').on('show.bs.modal', function () {
            $(this).closest("body").addClass("modal-is-open");
        });
        $('body div.modal').on('hidden.bs.modal', function () {
            if(!$(".modal.show").length) {
                $(this).closest("body").removeClass("modal-is-open");
            } else {
                $(this).closest("body").addClass("modal-open");
            }
        });
    });




    /**
     * замена всех стандартных инпутов с класом material-description
     * на модельные окна
     * */
    var modalDescription = 0;
    window.generatePopupDescription = function(th) {
        modalDescription++;
        var id = "modal-description-" + modalDescription;
        th.attr('data-toggle', 'modal');
        th.attr('data-target', '#' + id);
        var placeholder = $.trim(th.find("label").text());
        var dataSubmitText = $.trim(th.attr("data-submit-text"));
        var textareaPlaceholder = $.trim(th.attr("data-placeholder"));
        var submit = ''
        if (dataSubmitText) {
            submit = '<button class="submit btn btn-outline-warning" data-dismiss="modal" aria-label="Close" type="button">'+dataSubmitText+'</button>';
        }

        var selectModalHtml = '<div class="modal fade" id="'+id+'" tabindex="-1" role="dialog" aria-labelledby="'+id+'Label" aria-hidden="true">\n' +
            '                    <div class="modal-dialog form" role="document">\n' +
            '                        <div class="modal-content">\n' +
            '                            <div class="modal-header">\n' +
            '                                <h5 class="modal-title" id="'+id+'Label">'+$.trim(placeholder.replace('*', ''))+'</h5>\n' +
            '                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>\n' +
            submit +
            '                            </div>\n' +
            '                            <div class="modal-body">\n' +
            '                                <div class="textarea-wraper">';
        selectModalHtml += '<textarea placeholder="'+textareaPlaceholder+'" class="form-control" name="" id=""></textarea>';
        selectModalHtml += '</div></div></div></div></div>';
        $("#modals-wraper").append(selectModalHtml);
        th.find("input[disabled]").removeAttr("disabled");

        var newModal = $('#' + id);
        newModal.off('shown.bs.modal');
        newModal.on('shown.bs.modal', function (event) {
            var trigger = $(event.relatedTarget);
            var textarea = newModal.find("textarea");

            textarea.off("keyup");
            textarea.on("keyup", function () {
                trigger.find("input").val($.trim(textarea.val()));
            });

            textarea.focus();
        });

        newModal.off('show.bs.modal');
        newModal.on('show.bs.modal', function (event) {
            var trigger = $(event.relatedTarget);
            var textarea = newModal.find("textarea");
            var currentVal = trigger.find("input").val();
            if (currentVal) {
                textarea.val(currentVal);
            }
        });
    }
    $(".material-description.form-group").each(function() {
        window.generatePopupDescription($(this));
    });

    /**
     * замена стандартных селектов на кастомный селект в виде модального окна
     * */
    var modalSelectI = 0;
    window.generatePopupSelect = function (select) {
        var next = select.next(".material-select");
        if (next.length) {
            var modalId = next.attr("data-target");
            if (modalId) {
                $(modalId).remove();
            }

            next.remove();
        }

        modalSelectI++;
        var parent = select.closest(".form-group");
        var placeholder = $.trim(select.find("option").eq(0).text());
        var id = "modalSelectI_" + modalSelectI;
        var materialSelectId = "material-popup-select-" + modalSelectI;
        var selectModalHtml = '<div class="modal fade" id="'+id+'" tabindex="-1" role="dialog" aria-labelledby="'+id+'Label" aria-hidden="true">\n' +
            '                    <div class="modal-dialog form" role="document">\n' +
            '                        <div class="modal-content">\n' +
            '                            <div class="modal-header">\n' +
            '                                <h5 class="modal-title" id="'+id+'Label">' + placeholder.replace('*', '') + '</h5>\n' +
            '                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>\n' +
            '                            </div>\n' +
            '                            <div class="modal-body">\n' +
            '                                <div class="modal-select">';



        var textValue = "";
        var selectOptions = select.find("option");
        var valSelectOptions = select.find("option[value!='']");
        var selected = false;
        var icoSpan = "";
        selectOptions.each(function() {
            var sel = $(this);
            var selVal = sel.val();
            var selText = $.trim(sel.text());
            var dataIcoClass = sel.attr("data-ico-class");
            var dataSvgIcoId = sel.attr("data-svg-ico-id");
            selected = sel.is(":selected");
            if (selected) {
                textValue = selText;
            }
            var ico = ((dataIcoClass && dataSvgIcoId) ? true : "");
            if (ico === true) {
                ico = '<i class="'+dataIcoClass+'"><svg><use xlink:href="/images/sprite.svg?ver=sprite1#'+dataSvgIcoId+'"></use></svg></i>';
            }
            if (selVal) {
                if (!icoSpan) icoSpan = ico;
                selectModalHtml += '<div data-val="'+selVal+'" class="option">'+ ico + "<span class=\"txt\">" + selText+'</span></div>';
            }
        });

        var selectModal = '<div id="'+materialSelectId+'" class="form-group '+(!valSelectOptions.length ? 'no-vals' : '')+' material-select has-float-label" data-toggle="'+(valSelectOptions.length ? 'modal' : '')+'" data-target="#' + id + '">'+icoSpan+'<input readonly class="form-control" type="text" value="' + (textValue ? textValue : "") + '" placeholder=" " /><label>' + placeholder + '</label></div>';

        selectModalHtml += '</div></div></div></div></div>';

        parent.find(".form-control.modal-select").remove();
        select.after(selectModal);
        select.addClass("d-none");
        select.removeAttr("disabled");
        $("#modals-wraper").append(selectModalHtml);

        var newModal = $('#' + id);
        newModal.off('shown.bs.modal');
        newModal.on('shown.bs.modal', function (event) {
            var trigger = $(event.relatedTarget);
            var targetSelect = trigger.prev("select");
            var optionElements = newModal.find(".modal-select .option");
            optionElements.off("click");
            optionElements.on("click", function () {
                var th = $(this);
                var clickVal = th.attr("data-val");
                var svgIco = th.find(".svg-ico");
                var ico = "";
                if (svgIco.length) {
                    ico = $.trim(svgIco[0].outerHTML);
                }

                select.val(clickVal);
                var input = $("#" + materialSelectId + ' input');
                var inputIco = input.prev(".svg-ico");
                if (inputIco.length && ico) {
                    input.closest(".form-group").prepend(ico);
                    inputIco.remove();
                }

                input.val((clickVal ? $.trim(th.find(".txt").text()) : ""));
                newModal.modal("hide");

                select.change();
            });
        });

        return newModal;
    }
    $("select.form-control.material[multiple!='multiple']").each(function() {
        window.generatePopupSelect($(this));
    });
















    /**
     * замена стандартных мульти селектов на кастомные селекы в виде модального окна
     * */
    var modalMultiSelectI = 0;
    window.generatePopupMultipleSelect = function (select) {
        /**
         * перед созданием проверяем, если модалки уже созданы - удаляем их
         * если кастомный селект уже создан, но удалям и его
         * */
        var next = select.next(".material-select");
        if (next.length) {
            var modalId = next.attr("data-target");
            if (modalId) {
                $(modalId).remove();
            }

            next.remove();
        }

        // дата атрибут - добавть или нет поле поиска
        var addSearch = (select.attr("data-show-search") ? true : false);


        /**
         * создаем html будущих модальных окон
         * */
        modalMultiSelectI++;
        var parent = select.closest(".form-group");
        var placeholder = select.find("option").eq(0).text();
        var id = "modalMultiSelectI_" + modalMultiSelectI;
        var materialSelectId = "material-popup-milti-select-" + modalMultiSelectI;
        var selectModalHtml = '<div class="modal fade" id="'+id+'" tabindex="-1" role="dialog" aria-labelledby="'+id+'Label" aria-hidden="true">\n' +
            '                    <div class="modal-dialog form" role="document">\n' +
            '                        <div class="modal-content">\n' +
            '                            <div class="modal-header">\n' +
            '                                <h5 class="modal-title" id="'+id+'Label">'+$.trim(placeholder.replace('*', ''))+'</h5>\n' +
            '                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>' +
            '                                   <button class="submit btn btn-outline-primary" data-dismiss="modal" aria-label="Close" type="button">Зберегти</button>\n\n' +
            '                            </div>\n' +
            '                            <div class="modal-body">\n' +
            '                                <div class="modal-select">';

        if (addSearch) {
            selectModalHtml += '<div class="search form-group has-float-label ">\n' +
                '<input id="input-label-search-'+id+'" name="search" value="" class="form-control" type="text" autocomplete="off" autofocus="" placeholder=" ">\n' +
                '<label for="input-label-search-'+id+'">Поиск</label>\
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="clear-svg right-svg search-ico" viewBox="0 0 16 16"> \n\
                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/> \n\
                </svg></div>';
        }

        var textValue = [];
        var eachI = 0;
        var textValueI = 0;

        var selectOptions = select.find("option");
        var valSelectOptions = select.find("option[value!='']");
        selectOptions.each(function() {
            var sel = $(this);
            var selVal = sel.val();
            var selText = $.trim(sel.text());

            var labelName = id + "-modalMultiSelectLabel_" + eachI;
            var selected = sel.is(":selected");
            if (selected) {
               textValue[textValueI++] = selText;
            }

            if (selVal) {
                selectModalHtml += '<label for="'+labelName+'" class="option custom-control custom-checkbox"><input '+(selected ? "checked=\'checked\'" : "")+' value="'+selVal+'" name="'+labelName+'" type="checkbox" class="custom-control-input" id="'+labelName+'"><span class="custom-control-label">'+selText+'</span></label>\n';
            }
            eachI++;
        });
        selectModalHtml += '</div></div></div></div></div>';

        /**
         * создаем html замены текущего мультиселекта на кастомный
         * */
        var selectModal = '<div data-modal-id="'+id+'" id="'+materialSelectId+'" class="form-group '+(!valSelectOptions.length ? 'no-vals' : '')+' material-select has-float-label" data-toggle="'+(valSelectOptions.length ? 'modal' : '')+'" data-target="#' + id + '"><input readonly class="form-control" type="text" value="' + (textValue.length ? textValue.join(", ") : '') + '" placeholder=" " /><label>'+placeholder+'</label></div>';

        parent.find(".form-control.modal-select").remove();
        select.after(selectModal); // вставляем сгенерированный селект после стандартного
        select.addClass("d-none"); // скрываем стандартный
        select.removeAttr("disabled");
        $("#modals-wraper").append(selectModalHtml); // добавляем модальное окно с кастомным селектом в див со всми модалками



        /**
         * навешиваем собития на созданное модальное окно
         * */
        var newModal = $('#' + id);
        newModal.off('shown.bs.modal');

        /** при открытии модальки добавляем событие которое будет случшать поставленные чекбоксы
         * и отмечать их в стандартном мультиселекте
         * */
        newModal.on('shown.bs.modal', function (event) {
            console.log("open " + id);
            var trigger = $(event.relatedTarget);
            var targetSelect = trigger.prev("select");
            var searchAutofocus = (targetSelect.attr("data-search-autofocus") ? true : false);
            var labels = newModal.find(".modal-select .option");
            var optionElements = labels.find("input[type='checkbox']");

            optionElements.off("click");
            optionElements.on("click", function (event) {
                event.stopPropagation();
                var th = $(this);
                var option = targetSelect.find("option[value='"+th.val()+"']");

                if (option.length) {
                    if (th.is(":checked")) {
                        option.attr("selected", "selected");
                    } else {
                        option.removeAttr("selected");
                    }
                }

                targetSelect.change();
            });

            var searchInput = newModal.find(".modal-select .search input");
            if (searchInput.length) {
                if (searchAutofocus) {
                    searchInput.focus();
                }

                searchInput.off("change keyup input");
                searchInput.on("change keyup input", function (){
                    var th = $(this);
                    var val = $.trim(th.val().toLowerCase());
                    if (val) {
                        labels.each(function() {
                            var label = $(this);
                            var txt = $.trim(label.find(".custom-control-label").text()).toLowerCase();
                            if(txt.indexOf(val) >= 0) {
                                label.show();
                            } else {
                                label.hide();
                            }
                        });
                    } else {
                        labels.show();
                    }
                });
            }
        });

        newModal.off('hide.bs.modal');
        /**
         * при закрытии модалки смотрим проставленные значения в мутильтиселекте и обновляем значение valu
         * */
        newModal.on('hide.bs.modal', function (event) {
            var selected = select.find(":selected");
            if (selected.length) {
                var textValue = [];
                var eachI = 0;
                selected.each(function() {
                    var th = $(this);
                    textValue[eachI] = $.trim(th.text());
                    eachI++;
                });
                $("#" + materialSelectId + ' input').val(textValue.join(", "));
            } else {
                $("#" + materialSelectId + ' input').val("");
            }
            console.log("hide");
        });



        return newModal;
    }
    $("select.form-control.material[multiple]").each(function() {
        var select = $(this);
        if (select.is("[data-popup-managed='external']")) {
            return;
        }
        window.generatePopupMultipleSelect(select);
    });


    /*
    //$(function () {
        $(window).on('scroll', function () {
            if ( $(window).scrollTop() > 10 ) {
                $('.navbar').addClass('active');
            } else {
                $('.navbar').removeClass('active');
            }
        });
    //});

     */


});

// фокусировка на инпуте что бы курсор был вхонце
window.inputFocus = function(input) {
    var val = input.val();
    input.val("");
    input.focus();
    input.val(val);
}
